import { GetOpportunitiesDataResponse } from "@/pages/explorer/types";
import { Markdown } from "@altimateai/lego";
import ExpandableText from "@/components/expandableText/ExpandableText";

const InsightDescription = ({
  opportunity,
  className,
}: {
  opportunity: GetOpportunitiesDataResponse;
  className?: string;
}) => {
  return (
    <div className={`al-text-muted-foreground al-mb-4 al-text-sm al-min-h-[3rem] ${className}`}>
      {opportunity.description ? (
        <ExpandableText lines={2} moreText="see more" lessText="see less">
          <Markdown
            content={opportunity.description}
            components={{
              a: ({ ...props }) => (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  {...props}
                  target="_blank"
                  style={{ color: "#247EFE", textDecoration: "underline" }}
                  rel="noreferrer"
                />
              ),
            }}
          />
        </ExpandableText>
      ) : null}
    </div>
  );
};

export default InsightDescription;
